import { render } from "./PricingIcon.vue?vue&type=template&id=27ca4114"
import script from "./PricingIcon.vue?vue&type=script&lang=js"
export * from "./PricingIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__